module.exports = {
  src: __webpack_public_path__ + "assets/images/chevron-down-icon.cb7798f8b8d820b5.svg",
  width: 12,
  height: 12,
  toString: function() { return __webpack_public_path__ + "assets/images/chevron-down-icon.cb7798f8b8d820b5.svg"; }
};